import differenceInMinutes from 'date-fns/difference_in_minutes'
import differenceInHours from 'date-fns/difference_in_hours'
import differenceInDays from 'date-fns/difference_in_days'
import format from 'date-fns/format'
import isEmpty from 'lodash/isEmpty'

export default {
  methods: {
    dateFormatter (date, type = 'default', prefix = true, minuteTxt = 'minute', hourTxt = 'hour', dayTxt = 'day') {
      if (!date) return ''

      let isAgo = true
      let content = ''
      let result = ''
      const now = new Date()
      const compareDate = new Date(date)
      const diffInMins = differenceInMinutes(now, compareDate)
      const diffInHours = differenceInHours(now, compareDate)
      const diffInDays = differenceInDays(now, compareDate)
      if (diffInDays > 3) {
        // More than 3 days ago:
        isAgo = false
        let dateString = format(compareDate, 'D MMM, YYYY h:mma')
        const timezoneString = compareDate.toString().match(/\(([A-Za-z\s].*)\)/)
        let timezone = ''

        if (!isEmpty(timezoneString) && timezoneString.length === 2) {
          timezone = timezoneString[1]
        }

        if (type === 'simple') {
          dateString = format(compareDate, 'D MMM, YYYY')
          content = `${prefix ? 'Published on ' : ''}${dateString}`
        } else {
          content = `${prefix ? 'Published on ' : ''}${dateString} ${timezone}`
        }
      } else if (diffInDays >= 1) {
        // 1 – 3 days ago:
        content = `${prefix ? 'Published ' : ''}${diffInDays} ${dayTxt}`
        content += diffInDays > 1 ? 's' : ''
      } else if (diffInHours >= 1) {
        // Within 1 day
        // 1 hour or more than 1 hour:
        content = `${prefix ? 'Published ' : ''}${diffInHours} ${hourTxt}`
        content += diffInHours > 1 ? 's' : ''
      } else {
        // Within 1 day
        // Display minutes when it is 1 – 59 min ago, e.g.
        content = `${prefix ? 'Published ' : ''}${diffInMins} ${minuteTxt}`
        content += diffInMins > 1 ? 's' : ''
      }
      result = isAgo ? content += ' ago' : content

      if (type === 'html') {
        return `<span class="date-wrap">${result}</span>`
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/dateFormatter.js